const BASE64URL_PATTERN = /^[A-Za-z0-9_-]+$/u;

export function encodeBase64Url(bytes: Uint8Array): string {
  let binary = "";
  for (const byte of bytes) {
    binary += String.fromCharCode(byte);
  }

  return btoa(binary).replaceAll("+", "-").replaceAll("/", "_").replace(/=+$/u, "");
}

export function decodeBase64Url(value: string): Uint8Array {
  if (value.length === 0 || !BASE64URL_PATTERN.test(value)) {
    throw new Error("Invalid base64url value.");
  }

  const paddingLength = (4 - (value.length % 4)) % 4;
  const base64 = value.replaceAll("-", "+").replaceAll("_", "/");

  let binary: string;
  try {
    binary = atob(`${base64}${"=".repeat(paddingLength)}`);
  } catch {
    throw new Error("Invalid base64url value.");
  }

  const decoded = Uint8Array.from(binary, (character) => character.charCodeAt(0));
  if (encodeBase64Url(decoded) !== value) {
    throw new Error("Non-canonical base64url value.");
  }

  return decoded;
}

export function decodeFixedBase64Url(
  value: string,
  expectedBytes: number,
  label: string,
): Uint8Array {
  const decoded = decodeBase64Url(value);
  if (decoded.byteLength !== expectedBytes) {
    throw new Error(`${label} must contain ${String(expectedBytes)} bytes.`);
  }
  return decoded;
}
